export default {
    meta: null,
    content: null,
    error: null,
    loading: false
  };
  